import React from 'react'
import { Grid, Typography, Card, CardContent } from '@mui/material'

const ComplaintAboutBookedLesson = ({ bookedLesson }) => {
  return (
    <Grid item>
      <Card>
        <CardContent>
          <Grid container direction='column'>
            <Grid item>
              <Typography variant='h5' style={{ textAlign: 'center' }}>Complaint of student</Typography>
            </Grid>

            <Grid item>
              <Typography variant='body1'><strong>Content:</strong> {bookedLesson.complaint.content}</Typography>
            </Grid>

            <Grid item>
              <Typography variant='body1'><strong>Student requested for a refund: </strong>{bookedLesson.complaint.isRequestedRefund ? 'Yes' : 'No'}</Typography>
            </Grid>

            <Grid item>
              <Typography variant='body1'><strong>Status: </strong>{bookedLesson.complaint.isSolved ? 'Complaint has been solved.' : 'Complaint has not been solved yet.'}</Typography>
            </Grid>
          </Grid>
        </CardContent>

      </Card>
    </Grid>
  )
}

export default ComplaintAboutBookedLesson
